var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xems-spinner",class:{
        'xems-spinner-small': _vm.size === 'small',
        'xems-spinner-medium': _vm.size === 'medium',
        'xems-spinner-large': _vm.size === 'large',
    }},[_c('div',{staticClass:"xems-spinner-loader"})])
}
var staticRenderFns = []

export { render, staticRenderFns }